
import { Options, Vue } from "vue-class-component";
import { useStore }     from "vuex";
import { key }          from "@/store";

@Options( {} )
export default class Actions extends Vue
{
  store = useStore( key );
}
